import ErrorComponent from "@/components/atoms/ErrorComponent";
import TeamHeader from "@/components/molecules/card-headers/teams/TeamHeader";
import TeamDetailsCard from "@/components/molecules/cards/teams/TeamDetailsCard";
import { UUID_REGEX } from "@/constants/regexs";
import { FC } from "react";
import { useParams } from "react-router-dom";

const TeamView: FC = () => {
  const { id } = useParams<{ id: string }>();

  if (!id || !UUID_REGEX.test(id)) {
    return (
      <ErrorComponent error={{ status: 404, data: {} }} absolute returnButton />
    );
  }

  return (
    <div className="formalys-page formalys-detail-page">
      <TeamHeader id={id} />
      <TeamDetailsCard id={id} />
    </div>
  );
};

export default TeamView;
